export default function doseAtDays(props) {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="35" height="35" rx="11.5" fill="white" stroke="#EAEBEC" />
      <circle cx="18" cy="18" r="3" fill="url(#paint0_radial_1129_33555)" />
      <defs>
        <radialGradient
          id="paint0_radial_1129_33555"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(17.6838 15) rotate(81.7922) scale(11.347 13.4566)"
        >
          <stop stopColor="#253FC4" />
          <stop offset="1" stopColor="#000D4F" />
        </radialGradient>
      </defs>
    </svg>
  );
}
